import React from 'react';
import { string } from 'prop-types';

import theme from '../../config/theme';

StatusIcon.propTypes = {
  status: string,
};

StatusIcon.defaultProps = {
  status: null,
};

function StatusIcon({ status }) {
  return (
    <React.Fragment>
      {status === 'APPROVED' && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
          <path
            d="M26 0C11.664 0 0 11.663 0 26s11.664 26 26 26 26-11.663 26-26S40.336 0 26 0zm14.495 17.329l-16 18a1.997 1.997 0 0 1-2.745.233l-10-8a2 2 0 0 1 2.499-3.124l8.517 6.813L37.505 14.67a2.001 2.001 0 0 1 2.99 2.659z"
            fill={theme.color.teal}
          />
        </svg>
      )}

      {status === 'REJECTED' && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 485.811 485.811">
          <path
            d="M476.099 353.968l-170.2-294.8c-27.8-48.7-98.1-48.7-125.8 0l-170.3 294.8c-27.8 48.7 6.8 109.2 62.9 109.2h339.9c56.1 0 91.3-61.1 63.5-109.2zm-233.2 43.8c-14.8 0-27.1-12.3-27.1-27.1s12.3-27.1 27.1-27.1 27.1 12.3 26.5 27.8c.7 14.1-12.3 26.4-26.5 26.4zm24.7-175.2c-1.2 21-2.5 41.9-3.7 62.9-.6 6.8-.6 13-.6 19.7-.6 11.1-9.3 19.7-20.4 19.7s-19.7-8-20.4-19.1c-1.8-32.7-3.7-64.8-5.5-97.5-.6-8.6-1.2-17.3-1.9-25.9 0-14.2 8-25.9 21-29.6 13-3.1 25.9 3.1 31.5 15.4 1.9 4.3 2.5 8.6 2.5 13.6-.6 13.7-1.9 27.3-2.5 40.8z"
            fill={theme.color.red}
          />
        </svg>
      )}

      {status === 'UPDATED' && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 723.266 723.267">
          <g fill={theme.color.orange}>
            <path d="M361.104 404.382c12.771 0 24.138-5.546 32.168-14.221h63.635c16.383 0 29.66-13.3 29.66-29.683 0-16.372-13.288-29.683-29.66-29.683H393.25c-6.788-7.363-16.038-12.288-26.496-13.645l-56.697-79.811c-9.503-13.346-28.038-16.487-41.384-6.983-13.346 9.48-16.487 28.015-7.006 41.383l56.559 79.615c-.621 2.957-.978 5.982-.978 9.124.01 24.264 19.649 43.904 43.856 43.904z" />
            <path d="M440.19 65.65l7.007 6.523c6.868 6.408 10.814 15.486 10.814 24.874a34.065 34.065 0 0 1-10.814 24.851l-22.804 21.25c88.555 26.013 154.928 104.132 163.096 198.945h-26.657c-10.906 0-19.777 8.859-19.777 19.777 0 10.941 8.883 19.8 19.777 19.8h26.75c-8.859 102.44-85.713 185.496-185.082 204.215v-42.834a14.254 14.254 0 0 0-8.525-13.035 14.304 14.304 0 0 0-15.383 2.646l-89.049 82.997a14.29 14.29 0 0 0-4.51 10.412c0 3.936 1.645 7.697 4.51 10.39l89.049 82.997a14.25 14.25 0 0 0 15.383 2.623c5.166-2.266 8.525-7.386 8.525-13.012v-42.938c.333-.022.644.104.978.069 149.301-21.031 264.156-149.231 264.156-304.32-.001-142.039-96.551-261.013-227.444-296.23z" />
            <path d="M265.255 626.223a34.064 34.064 0 0 1 10.815-24.852l22.803-21.25c-88.554-26.013-154.927-104.132-163.096-198.945h26.657c10.907 0 19.777-8.858 19.777-19.777 0-10.941-8.871-19.777-19.777-19.777h-26.749c8.859-102.464 85.712-185.519 185.082-204.238v42.833c0 5.649 3.36 10.769 8.525 13.035a14.277 14.277 0 0 0 15.371-2.646l89.049-82.998a14.249 14.249 0 0 0 4.51-10.412c0-3.935-1.645-7.697-4.51-10.389L344.664 3.81a14.212 14.212 0 0 0-15.371-2.623c-5.166 2.267-8.525 7.386-8.525 13.012v42.937c-.333.023-.644-.115-.978-.069C170.488 78.11 55.633 206.311 55.633 361.399c0 142.018 96.539 260.992 227.443 296.22l-7.006-6.512a34.155 34.155 0 0 1-10.815-24.884z" />
          </g>
        </svg>
      )}
    </React.Fragment>
  );
}

export default StatusIcon;



// WEBPACK FOOTER //
// ./src/components/Menu/StatusIcon.js